import CaregiverHcrStateCompliancePage from "./CaregiverHcrStateCompliancePage";

export default function CaregiverHcrStateComplianceRoute() {
  return (
    <>
      <CaregiverHcrStateCompliancePage />
    </>
  );
}
